export const STORAGE_KEY = 'VF-PATHFINDER';
